export { LogoutComponent } from './logout.component';
